import { mapGetters, mapActions } from 'vuex'
import { storageUtil } from '@/util'

import { ExpansionPanel, TotalAmount } from '@/components/items'
import NormalButton from '@/components/items/Buttons/NormalButton'

import ClientSearch from '@/components/layouts/ClientSearchArea/ClientSearchAreaStorageAdjust'
import ClientInfo from '@/components/layouts/ClientInfo/StorageAdjust/ClientInfo'
import ProductSearch from '@/components/layouts/ProductSearchArea/ProductSearchAreaStockAdjust'
import ProductInfo from '@/components/layouts/ProductInfo/StorageAdjust/ProductInfo'

import RegisterDialog from '@/components/layouts/Dialogs/MultipleArea/StorageAdjustInfoDialog/StorageAdjustRegisterDialog'

import DialogAlertError from '@/components/layouts/Dialogs/DialogAlert/DialogAlertError'
import { i18n } from '@/main.js'

export default {
  name: 'StockAdjust',

  components: {
    ExpansionPanel,
    NormalButton,

    ClientSearch,
    ClientInfo,
    ProductSearch,
    ProductInfo,

    TotalAmount,
    RegisterDialog,

    DialogAlertError
  },
  data: () => {
    return {
      pageTitle: i18n.tc('common.common_stock-adjust'),

      pageType: {
        en: 'stockAdjust',
        ja: '在庫調整'
      },

      dialog: {
        dialog: false
      },

      registerData: {
        client: {},
        product: {
          isHistory: false,
          data: []
        }
      },

      clientAreaInfo: {
        isOpen: true,
        isSelect: false,
        selectInfo: {}
      },
      selectCurrency: { currencyId: null, name: '', unitName: '' },
      history: {
        productMoves: []
      },

      productSearchInfo: {
        keyword: '',
        category: ''
      },

      errMessage: '',
      errDialog: false,

      client: [],
      productInputData: [],
      productInputDataForShip: [],
      loadingItems: [],
    }
  },
  async created() {
    await this.getCountryListFromApi()
  },
  methods: {
    ...mapActions('Common', ['getCountryListFromApi']),
    ...mapGetters('Common', ['getCurrencyJpFromState']),
    ...mapActions('Stock', ['registerStockAdjust']),

    opnePanel(...args) {
      const [index] = args
      this.clientAreaInfo.isOpen = index.length > 0
    },

    selectStorageRecipient(...args) {
      const [storageRecipient] = args
      // alert(JSON.stringify(storageRecipient))

      const isExist = true
      this.clientAreaInfo = {
        isOpen: isExist,
        isSelect: isExist,
        selectInfo: storageRecipient
      }
    },
    changeClient(...args) {
      const [clientInfo] = args

      const storageInfo = storageUtil.getStorageById(clientInfo.storage.value)

      const isExist = true
      this.clientAreaInfo = {
        isOpen: isExist,
        isSelect: isExist,
        selectInfo: storageInfo
      }

      // const isHistory = type === 'history'
      // this.history.productMoves = isHistory ? clientInfo.productMoves : []
    },
    changeClientInfo(...args) {
      const [clientInfo] = args
      this.registerData.client = clientInfo
    },

    inputKeyword(...args) {
      const [keyword] = args
      this.productSearchInfo.keyword = keyword
    },
    selectCategory(...args) {
      const [categoryId] = args
      this.productSearchInfo.category = categoryId
    },

    changeProductInfo(...args) {
      const [isHistory, productInfo] = args

      // const clientInfo = this.clientAreaInfo.selectInfo

      // const totalList = this.registerData.totalList
      // if (isHistory) {
      //   totalList.tax10.tax = clientInfo.consumptionTax10
      //   totalList.tax8.tax = clientInfo.consumptionTax8
      //   totalList.discount = clientInfo.discount
      //   totalList.shipping = clientInfo.comission
      // }
      // totalList.tax10.tax = isHistory ? clientInfo.consumptionTax10 : 0
      // totalList.tax8.tax = isHistory ? clientInfo.consumptionTax8 : 0
      // totalList.discount = isHistory ? clientInfo.discount : 0
      // totalList.shipping = isHistory ? clientInfo.comission : 0

      this.registerData.product = {
        isHistory: isHistory,
        data: productInfo.filter((ele) => ele.count && ele.count != 0)
      }
    },

    register() {
      if (!this.clientAreaInfo.isSelect) {
        alert(this.$t('common.common_select-storage'))
        // this.errMessage = '顧客を選択してください'
        // this.errDialog = true
        return
      }
      if (!this.registerData.product.data.length) {
        alert(this.$t('product.product_select-product'))
        // this.errMessage = '商品を選択してください'
        // this.errDialog = true
        return
      }
      this.dialog.dialog = true
    },

    parentEvent(csvRows, csvRows2) {
      if (!this.clientAreaInfo.isSelect) {
        alert(this.$t('common.common_select-storage'))
        // this.errMessage = '顧客を選択してください'
        // this.errDialog = true
        return
      }

      //console.log('csvRows_parent')
      //console.log(csvRows)

      var result = window.confirm('一括在庫調整を行います。よろしいですか？')

      if (result) {
        this.bulkRegister(csvRows, csvRows2)
      }
    },

    async bulkRegister(csvRows, csvRows2) {
      const isSuccess = await this.registerStockAdjust({
        clientData: this.registerData.client,
        loadingData: csvRows,
        shipData: csvRows2,
        remarks: null
      })
      if (isSuccess) {
        alert('一括在庫調整が完了しました。')
        // 在庫調整履歴一覧へ遷移
        this.$router.push({ name: 'storage.adjust.history' })
      }
    }
  },
  watch: {}
}
